<template>
  <div class="employee-card">
    <div class="employee-card__info">
      <div class="employee-card__photo">
        <img :src="manager.photo" alt="" />
      </div>
      <div class="employee-card__data">
        <p class="employee-card__name">
          {{ manager.name }}
        </p>
        <p class="employee-card__position">
          {{ manager.position }}
        </p>
      </div>
    </div>
    <div class="employee-card__contact">
      <div class="employee-card__comm-w">
        <a
          class="employee-card__comm"
          :href="`tel:${manager.phone}`"
          target="_blank"
        >
          <img
            class="employee-card__comm-img"
            src="~~/assets/icons/phone.svg"
            alt=""
          />
          <span>{{ manager.phone }}</span>
        </a>
        <div
          v-if="manager.viber || manager.telegram"
          class="employee-card__messengers"
        >
          <a
            v-if="manager.viber"
            class="employee-card__messenger"
            :href="viberFormatPhone(manager.viber)"
            target="_blank"
          >
            <img
              class="employee-card__messenger-img"
              src="~~/assets/icons/contactsManagerViber.svg"
              alt=""
            />
          </a>
          <a
            v-if="manager.telegram"
            class="employee-card__messenger"
            :href="telegramFormatPhone(manager.telegram)"
            target="_blank"
          >
            <img
              class="employee-card__messenger-img"
              src="~~/assets/icons/contactsManagerTelegram.svg"
              alt=""
            />
          </a>
        </div>
      </div>
      <a
        v-if="manager?.email"
        class="employee-card__comm"
        :href="`mailto:${manager?.email}`"
        target="_blank"
      >
        <img
          class="employee-card__comm-img"
          src="~~/assets/icons/managerMailIcon.svg"
          alt=""
        />
        <span>{{ manager?.email }}</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import { formatPhone } from "~~/utils/phoneHelper";

defineProps({
  manager: { type: Object },
});

function telegramFormatPhone(telegram) {
  if (telegram.startsWith("+38")) {
    return "https://t.me/" + formatPhone(telegram);
  }

  return telegram;
}

function viberFormatPhone(viber) {
  if (viber.startsWith("+38")) {
    return "viber://chat/?number=%2B" + formatPhone(viber).replace("+", "");
  }

  return viber;
}
</script>

<style lang="scss" scoped>
.employee-card {
  @include flex-container(column, null, null);
  gap: 24px;

  padding: 10px;

  transition: all 0.5s ease;

  @include mobile {
    border-bottom: 1px solid #f3f3f3;
  }

  &:hover {
    box-shadow: 0 0 24px rgb(0 0 0 / 30%);
    border-radius: 8px;

    @include mobile {
      box-shadow: none;
      border-radius: 0;
    }
  }

  &__info {
    @include flex-container(row, flex-start, center);
    gap: 24px;

    @include mobile {
      gap: 16px;
    }
  }

  &__photo {
    flex: 0 0 90px;

    & img {
      border-radius: 50%;
    }
  }

  &__data {
    @include flex-container(column, null, null);
    gap: 2px;

    @include mobile {
      gap: 6px;
    }
  }

  &__name {
    @include font(22, 26, 700);
    text-transform: capitalize;
    color: var(--color-primary-base);

    @include mobile {
      @include font;
    }
  }

  &__position {
    @include font(20, 24);
    font-style: italic;

    @include mobile {
      @include font(12, 16);
      font-style: normal;
    }
  }

  &__contact {
    @include flex-container(column, null, null);
    gap: 16px;

    & > span {
      @include font(14, 16);
    }
  }

  &__comm-w {
    @include flex-container(row, flex-start, center);
    gap: 16px;
  }

  &__comm {
    max-width: fit-content;

    @include flex-container(row, flex-start, center);
    gap: 16px;

    transition: color 0.2s ease;

    &:hover {
      color: var(--color-primary-dark);
    }

    @include mobile {
      gap: 24px;
    }
  }

  &__messengers {
    @include flex-container(row, flex-start, center);
    gap: 16px;
  }

  &__messenger {
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>
